import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, ParamMap } from '@angular/router';
// import { CheckTutorial } from './providers/check-tutorial';
import { AuthGuard } from "./common/guard/auth.guard";
const routes: Routes = [
  {
    path: '',  redirectTo: '/auth', pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'app',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/app/app.module').then( m => m.AppModule)
  },
  {
    path: 'about',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/about/about.module').then( m => m.AboutModule)
  },
  {
    path: 'camera',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/camera/camera.module').then( m => m.CameraModule)
  },
  {
    path: 'company',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/company/company.module').then( m => m.CompanyModule)
  },
  {
    path: 'faqs',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/faqs/faqs.module').then( m => m.FaqsModule)
  },
  {
    path: 'final',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/final/final.module').then( m => m.FinalModule)
  },
  {
    path: 'form',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/form/form.module').then( m => m.FormModule)
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomeModule)
  },
  {
    path: 'help',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/help/help.module').then( m => m.HelpModule)
  },
  {
    path: 'map',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/map/map.module').then( m => m.MapModule)
  },
  {
    path: 'payment',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/payment/payment.module').then( m => m.PaymentModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./pages/privacy/privacy.module').then( m => m.PrivacyModule)
  },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfileModule)
  },
  {
    path: 'rating',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/rating/rating.module').then( m => m.RatingModule)
  },
  {
    path: 'search',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/search/search.module').then( m => m.SearchModule)
  },
  {
    path: 'sgss',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/sgss/sgss.module').then( m => m.SgssModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/terms/terms.module').then( m => m.TermsModule)
  },
  {
    path: 'sign',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/signature/signature.module').then( m => m.SignatureModule)
  },
  {
    path: 'video',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/video/video.module').then( m => m.VideoModule)
  },
  {
    path: 'audio',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/audio/audio.module').then( m => m.AudioModule)
  },
  {
    path: 'workshop',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/workshop/workshop.module').then( m => m.WorkshopModule)
  },
  { path: '**', redirectTo: 'auth' },
];
// , { preloadingStrategy: PreloadAllModules,  paramsInheritanceStrategy: 'always',  urlUpdateStrategy: 'eager' }
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
